import React, { useState, useEffect } from 'react'
// Styles
import './cdt.style.css'
// Images
import ArrowBottomIcon from '../../assets/images/icons/arrow-b.png'
// Card (Platinum)
import PlatNhCard from '../../assets/images/cards/card NH (platinum).png'
import PlatNhBadge_Active from '../../assets/images/cards/platinum(active).png'
import PlatNhBadge_Inactive from '../../assets/images/cards/platinum(inactive).png'
// Icons
import IconListSuccess from '../../assets/images/icons/icon-list-success.png'

function CardDetails({ openDetail, setOpenDetail, cardData, cardDetail }) {

    // console.log('Card Detail: ', cardDetail);

    const handleCloseDetails = () => {
        setOpenDetail(false);
        document.body.style.overflow = 'scroll'
    }

    return (
        <div className={`cdt-container ${openDetail ? 'active' : ''}`}>
            {/* arrow */}
            <span 
                className="cdt-switch"
                onClick={handleCloseDetails}
            >
                <img src={ArrowBottomIcon} />
            </span>
            {/* Card Details */}
            {/* - card (img) */}
            <div className="card-img-wrap">
                <img src={cardData.cardImg_Lab} className="card" />
                <img src={cardData.cardIcon_Lab} className="badge" />
            </div>
            {/* header */}
            <h1 className="cdetail-header">เงื่อนไขการรับคะแนน</h1>
            {/* -(MockUp) card details */}
            {/* <div className="d-title">
                <span className="cdetail-label">การสะสมคะแนน</span>
                <p className="cdetail-text">• เกณฑ์การให้คะแนนเมื่อใช้จ่ายผ่านไลน์ @nhealth ดังนี้</p> 
            </div> */}
            {/* detail list */}
            {/* <div className="cdetail-list">
                <div className="item">
                    <img src={IconListSuccess} />
                    <span className="t-black">เมื่อใช้จ่ายตั้งแต่ 300 บาท ถึง 1,999 บาท รับทันที 10 คะแนน</span>
                </div>
                <div className="item">
                    <img src={IconListSuccess} />
                    <span className="t-black">เมื่อใช้จ่ายตั้งแต่ 2,000 บาท ถึง 4,999 บาท รับทันที 20 คะแนน</span>
                </div>
                <div className="item">
                    <img src={IconListSuccess} />
                    <span className="t-black">เมื่อใช้จ่ายตั้งแต่ 5,000 บาท ถึง 7,999 บาท รับทันที 30 คะแนน</span>
                </div>
                <div className="item">
                    <img src={IconListSuccess} />
                    <span className="t-black">เมื่อใช้จ่ายตั้งแต่ 8,000บาทขึ้นไป รับทันที 50คะแนน</span>
                </div>
            </div>
            <p className="cdetail-text">• คะแนนสะสมต่อ 1 ใบเสร็จ และไม่สามารถรวมยอดใบเสร็จได้</p>
            <p className="cdetail-text">• ทางบริษัทสงวนสิทธิ์ในการเปลี่ยนแปลงคะแนนสะสม โดยไม่ต้องแจ้งให้ทราบล่วงหน้า</p>  */}

            {/* Accumulation */}
            <div dangerouslySetInnerHTML={{__html: cardDetail.accumulation}}></div>
            {/* Dividing Line */}
            <div className="diviline-gray"></div>
            {/* Redemption */}
            <div dangerouslySetInnerHTML={{__html: cardDetail.redemption}}></div>

            {/* -(MockUp) card details */}
            {/* <div className="d-title">
                <span className="cdetail-label">การแลกคะแนนสะสม</span>
                <p className="cdetail-text">1. เมื่อมีการแลกคะแนนสะสม ระบบจะทำการหักคะแนนออกจากยอดคะแนนสะสมคงเหลือทันที</p> 
                <p className="cdetail-text">2. คะแนนสะสมนี้ไม่สามารถแลกหรือใช้แทนเงินสดได้</p> 
                <p className="cdetail-text">3. กรณีสมาชิกต้องการขอยกเลิกการเป็นสมาชิก และหากประสงค์จะแลกรับของรางวัล สมาชิกจะต้องทำการแลกของรางวัลก่อนยกเลิกการเป็นสมาชิก</p> 
                <p className="cdetail-text">4. เมื่อยกเลิกการเป็นสมาชิกคะแนนที่สะสมจะถูกยกเลิกคะแนนทั้งหมดโดยทันที</p> 
                <p className="cdetail-text">5. ระยะเวลาของการสะสมคะแนน ตั้งแต่วันที่ 1 มกราคม 2022 ถึง 31 ธันวาคม 2022</p> 
                <p className="cdetail-text">6. ทางบริษัทจะตัดคะแนนเป็น 0 คะแนน ของทุกวันที่ 31 ธันวาคม ของทุกปี</p> 
                <p className="cdetail-text">7. สิทธิพิเศษสำหรับสมาชิก ไม่สามารถโอน หรือเปลี่ยนกรรมสิทธิ์ได้</p> 
                <p className="cdetail-text">8. กรณีสามารถชิกไม่ได้รับสิทธิประโยชน์ หรือได้รับแต่ไม่ถูกต้อง โปรดติดต่อฝ่ายลูกค้าสัมพันธ์ของทางบริษัทฯ ภายใน 15 วัน นับจากวันที่สิ้นสุดรายการ มิเช่นนั้นจะถือว่าสมาชิกยอมรับว่าการดำเนินการของทางบริษัทฯ</p> 
                <p className="cdetail-text">9. บริษัทฯ ขอสงวนสิทธิ์ในการแก้ไขคะแนนสะสม หากตรวจสอบแล้วพบว่าการแลกคะแนนสะสมดังกล่าวไม่ตรงกับยอดสั่งซื้อสินค้าหรือบริการที่เกิดขึ้นจริง โดยไม่ต้องแจ้งให้ทราบล่วงหน้า</p> 
                <p className="cdetail-text">10. บริษัทฯ จะถือตามข้อมูลที่ปรากฎในระบบของบริษัทฯเป็นสำคัญ กรุณาเก็บหลักฐานการเข้าร่วมรายการ คำสั่งซื้อ สลิปการโอนไว้ตรวจสอบกรณีจำเป็น</p> 
                <p className="cdetail-text">11. ท่านสามารถตรวจสอบคะแนนสะสมของท่านได้ ผ่านทาง 3 ช่องทาง</p> 
                <p className="cdetail-text-2">• ตรวจสอบผ่าน Application LINE OA โดยคลิกปุ่มริชเมนู “NHEALTH CARD”</p>
                <p className="cdetail-text-2">• โทรสอบถามที่ฝ่ายลูกค้าสัมพันธ์ : 02-762-40000 กด 1 หรือ กด 9</p>
                <p className="cdetail-text-2">• สอบถามผ่านทางอีเมลที่ : nhealth-ecommerce@nhealth-asia.com</p>
                <p className="cdetail-text">12. ทางบริษัทสงวนสิทธิ์ในการเปลี่ยนแปลงสิทธิประโยชน์ ส่วนลด เงื่อนไขต่างๆ โดยไม่ต้องแจ้งให้ทราบล่วงหน้า และเป็นไปตามบริษัทฯ กำหนด</p> 
            </div> */}
        </div>
    )
}

export default CardDetails